if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        const prevButton = this.querySelector('.product-media-modal__prev');
        const nextButton = this.querySelector('.product-media-modal__next');
        if (prevButton) prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
        if (nextButton) nextButton.addEventListener('click', this.showNextMedia.bind(this));

        const content = this.querySelector('[role="document"]');
        if (content) {
          let touchStartX = 0;
          let touchStartY = 0;

          content.addEventListener(
            'touchstart',
            (event) => {
              touchStartX = event.touches[0].clientX;
              touchStartY = event.touches[0].clientY;
            },
            { passive: true }
          );

          content.addEventListener(
            'touchend',
            (event) => {
              const touchEndX = event.changedTouches[0].clientX;
              const touchEndY = event.changedTouches[0].clientY;
              const deltaX = touchEndX - touchStartX;
              const deltaY = touchEndY - touchStartY;

              if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
                if (deltaX < 0) {
                  this.showNextMedia();
                } else {
                  this.showPreviousMedia();
                }
              }
            },
            { passive: true }
          );

          let mouseStartX = 0;
          let mouseStartY = 0;
          let isMouseDragging = false;

          content.addEventListener('mousedown', (event) => {
            isMouseDragging = true;
            mouseStartX = event.clientX;
            mouseStartY = event.clientY;
            content.classList.add('product-media-modal__content--dragging');
          });

          const endMouseDrag = (event) => {
            if (!isMouseDragging) return;
            isMouseDragging = false;
            content.classList.remove('product-media-modal__content--dragging');

            const mouseEndX = event.clientX;
            const mouseEndY = event.clientY;
            const deltaX = mouseEndX - mouseStartX;
            const deltaY = mouseEndY - mouseStartY;

            if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
              if (deltaX < 0) {
                this.showNextMedia();
              } else {
                this.showPreviousMedia();
              }
            }
          };

          content.addEventListener('mouseup', endMouseDrag);
          content.addEventListener('mouseleave', () => {
            isMouseDragging = false;
            content.classList.remove('product-media-modal__content--dragging');
          });
          content.addEventListener('dragstart', (event) => event.preventDefault());
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;

        this.getMediaItems().forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.activateMedia(activeMedia);
      }

      showNextMedia() {
        const items = this.getMediaItems();
        if (items.length < 2) return;
        const currentIndex = items.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (currentIndex + 1) % items.length;
        this.activateMedia(items[nextIndex]);
      }

      showPreviousMedia() {
        const items = this.getMediaItems();
        if (items.length < 2) return;
        const currentIndex = items.findIndex((item) => item.classList.contains('active'));
        const previousIndex = (currentIndex - 1 + items.length) % items.length;
        this.activateMedia(items[previousIndex]);
      }
    }
  );
}